import { render, staticRenderFns } from "./UserAccountActions.vue?vue&type=template&id=9c70a6ba&scoped=true&"
import script from "./UserAccountActions.vue?vue&type=script&lang=js&"
export * from "./UserAccountActions.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountActions.vue?vue&type=style&index=0&id=9c70a6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70a6ba",
  null
  
)

export default component.exports